import { H1, H2 } from "@/components/ui/headings"
import { MainLayout } from "@/org-admins/layouts/MainLayout"
import { useQuery } from "@apollo/client"
import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { getOrganizationQuery } from "./api"
import CreateAccountForm from "./CreateAccountForm"

export const CreateAccountScreen = () => {
  const { memberInviteToken } = useParams<{ memberInviteToken: string }>()
  const { data: organization } = useQuery(getOrganizationQuery, {
    variables: { memberInviteToken },
  })
  const [showVerifyMessage, setShowVerifyMessage] = useState(false)

  return (
    <MainLayout showLogo={true}>
      {showVerifyMessage ? (
        <div className="mb-12">
          <H1>Verify your Email</H1>
          <H2>A verification link has been sent to your email address.</H2>
        </div>
      ) : (
        <>
          <div className="mb-12">
            <H1>
              Welcome to the Employer Admin Portal for
              <br />
              {organization?.organization.name}
            </H1>
            <H2>Create Your Employer Account</H2>
          </div>
          <CreateAccountForm
            memberInviteToken={memberInviteToken ?? ""}
            onCreationSuccess={() => setShowVerifyMessage(true)}
          />
        </>
      )}
    </MainLayout>
  )
}
